import React, { useState } from 'react';
import Pagination from '../../Common/Pagination';

export default function SiteQualifyingEvents({ logTypeName, logs, hide, onPrint }) {
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    const dateHourFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
    const [isClosed, setIsClosed] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    function handleSelectPage(pageNum) {
        setSelectedPage(pageNum);
    }

    let noItems = logs?.length === 0 && (<div className="centeredMessage"><h5>No Qualifying Events available.</h5></div>);

    let shownLogs = logs.slice((pageSize * selectedPage) - pageSize, (pageSize * selectedPage));
    let shownStartIndex = (pageSize * selectedPage) - pageSize;
    let shownEndIndex = (pageSize * selectedPage);

    let logListItems = !isClosed && logs && logs
        .map((log, index) => <tr className={index < shownStartIndex || index >= shownEndIndex ? "hidden" : "" } key={log.id}>
            <td><span>{log.id}</span></td>            
            <td className="tabular-nums">{log.startedAt && dateHourFormatter.format(new Date(log.startedAt))}</td>
            <td className="tabular-nums">{log.endedAt && dateHourFormatter.format(new Date(log.endedAt))}</td>
            <td className="tabular-nums" >{log.inspectionDue && dateFormatter.format(new Date(log.inspectionDue))}</td>
            <td>{log.rainfallTotal}</td>
            <td>{log.duration}</td>
            <td>{log.status}</td>
            <td className="smallScreen">
                <div className="log">
                    {log.id && (<div>
                        <span className="fieldDesc">ID:</span>
                        <span>{log.id}</span>
                    </div>)}
                    {log.startedAt && (<div>
                        <span className="fieldDesc">Start:</span>
                        <span className="whitespace-nowrap">{log.startedAt && dateHourFormatter.format(new Date(log.startedAt))}</span>
                    </div>)}
                    {log.endedAt && (<div>
                        <span className="fieldDesc">End:</span>
                        <span className="whitespace-nowrap">{log.endedAt && dateHourFormatter.format(new Date(log.endedAt))}</span>
                    </div>)}
                    {log.inspectionDue && (<div>
                        <span className="fieldDesc">Inspection Due:</span>
                        {log.inspectionDue && dateFormatter.format(new Date(log.inspectionDue))}
                    </div>)}
                    {log.rainfallTotal && (<div>
                        <span className="fieldDesc">Rainfall Total:</span>
                        {log.rainfallTotal}
                    </div>)}
                    {log.duration && (<div>
                        <span className="fieldDesc">Duration:</span>
                        {log.duration}
                    </div>)}
                    {log.status && (<div>
                        <span className="fieldDesc">Status:</span>
                        {log.status}
                    </div>)}
                </div>
            </td>
        </tr>);

    if (selectedPage > 1 && (pageSize * selectedPage) - logListItems.length > 0) {
        let emptyRows = Array.from(
            { length: (pageSize * selectedPage) - logListItems.length },
            (cv, i) => (<tr className="noBkg noPrint" key={`R${i}`}><td>&nbsp;</td></tr>));
        logListItems = logListItems.concat(emptyRows);
    }

    let printButton = (<button onClick={() => onPrint("Qualifying Events", "#qualifyingEvents")}>Print</button>);

    let logList = logListItems.length === 0 ? undefined : !isClosed &&
        (<>
            <table id="qualifyingEvents" className="itemList">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th className="date">Start</th>
                        <th className="date">End</th>
                        <th className="date">Inspection Due</th>
                        <th className="date">Rainfall Total</th>
                        <th className="date">Duration</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>{logListItems}</tbody>
            </table>
            <Pagination itemCount={logs.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={handleSelectPage}>
                {printButton}
            </Pagination>
        </>);

    //let selectLogType = onSelectLogType && (<span className="select" onClick={() => onSelectLogType()}><i className={logTypeSelected ? "dhicon-check-2" : "dhicon-check-empty"} /></span>);
    let selectLogType;

    let iconClass = isClosed ? "dhicon-right-open-2" : "dhicon-down-open-4";
    //let openClose = (<i className={`icon ${iconClass}`} onClick={() => setIsClosed(!isClosed)} />);
    let openClose;

    
    let logTypeNameDescription = (<div className="text-drhPalette-primary text-xl font-bold pt-3 pb-1 flex justify-between">
        <span>{logTypeName}</span>
        
    </div>);

    let hideClass = hide && "hidden"

    return (
        <div className={`logTypeContainer qualEvents ${hideClass}`}>
            {logTypeNameDescription}
            {logList}
            {noItems}
        </div>
    );
}